import entities from "utils/entities";

export const api = () => (next) => async (action) => {
  const { type, promise, schema, ...rest } = action;
  const isPromise = promise instanceof Promise;
  if (!isPromise || !type) {
    next(action);
    return;
  }

  next({ type: `${type}_REQUEST`, ...rest });
  try {
    const result = await promise;
    if (schema) {
      next({ type, ...rest, data: result, schema });
    }
    next({ type: `${type}_SUCCESS`, ...rest, result });
  } catch (error) {
    console.error(error);
    next({ type: `${type}_FAILURE`, ...rest, error });
  }
};

export const normalize = () => (next) => (action) => {
  const { type, schema, data, ...rest } = action;
  if (!schema || !data) {
    next(action);
    return;
  }

  const normalization = entities.normalize(data, schema);
  next({
    type: "ADD_ENTITIES",
    entities: normalization.entities,
  });

  next({
    type: `${type}_NORMALIZATION`,
    ...rest,
    ...normalization,
  });
};
